import { Cell } from "react-table";
import { BaseTooltip } from "src/components";
import { BaseContractStatus } from "src/components/BaseContractStatus";
import BaseNewTabLink from "src/components/BaseNewTabLink";
import Link from "src/components/PartnerLink";
import ProductTypeChangeLabel from "src/components/ProductTypeChangeLabel";
import { PagePath } from "src/pages/product/details";

const AccessAreaColumns = [
  {
    // 신청번호(난수) 대체 컬럼. 행 자체가 계약 단위라서 그 행의 계약 상세로 이동한다.
    Header: "계약 ID",
    accessor: "contractId",
    width: 120,
    Cell: ({ value }: Cell<any>) => {
      if (!value) {
        return "-";
      }
      return <BaseNewTabLink path={PagePath.contract.detail.replace(":id", value)} value={String(value)} ellipsis />;
    },
  },
  {
    Header: "상태",
    accessor: "contractStep",
    width: 80,
    Cell: ({ value }: Cell<any>) => {
      return <BaseContractStatus status={value} />;
    },
  },
  {
    Header: "계약명",
    accessor: "contractName",
    width: 160,
    Cell: ({ value }: Cell<any>) => {
      return (
        <div className="">
          <BaseTooltip contents={value ? value : "-"} />
        </div>
      );
    },
  },

  {
    Header: "상품명",
    accessor: "spaceProductName",
    width: 200,
    Cell: ({ value }: Cell<any>) => {
      return (
        <div className="w-100 text-left">
          <BaseTooltip contents={value} />
        </div>
      );
    },
  },
  {
    Header: "법인명/상호",
    accessor: "mbOrganizationName",
    width: 130,
    sticky: "left",
    Cell: ({ value }: Cell<any>) => {
      return <div className="w-100 text-left">{value ? <BaseTooltip contents={value} /> : "-"}</div>;
    },
  },
  {
    Header: "상품유형",
    accessor: "spaceProductType",
    width: 130,
    sticky: "left",
    Cell: ({ value }: Cell<any>) => {
      return <ProductTypeChangeLabel productType={value} />;
    },
  },

  {
    Header: "출입 그룹",
    accessor: "",
    width: 80,
    Cell: ({ row }: Cell<any>) => {
      const contractId = row.original.contractId;
      return (
        <BaseNewTabLink path={`${PagePath.contract.detail.replace(":id", contractId)}?tab=accessLevel`} value={'보기'} ellipsis />
      );
    },
  },
];

export default AccessAreaColumns;
